/* eslint-disable react/prop-types */
import { useTheme } from 'styled-components'

export const SuccessIcon = ({
    fill,
    width = '14px',
    height = '14px',
    ...props
}) => {
    const theme = useTheme()
    fill = fill ?? theme.palette.success.base.active

    return (
        <svg {...props} viewBox="0 0 14 14" height={height} width={width}>
            <path
                fill={fill}
                d="M7 .333A6.67 6.67 0 00.335 7a6.669 6.669 0 006.667 6.667A6.669 6.669 0 0013.667 7 6.67 6.67 0 007.001.333zm-1.333 10L2.334 7l.94-.94 2.393 2.387 5.06-5.06.94.946-6 6z"
            ></path>
        </svg>
    )
}

export const AlertIcon = ({
    fill,
    width = '14px',
    height = '14px',
    ...props
}) => {
    const theme = useTheme()
    fill = fill ?? theme.palette.danger.base.active

    return (
        <svg {...props} viewBox="0 0 14 14" height={height} width={width}>
            <path
                fill={fill}
                d="M7 .333A6.66 6.66 0 00.335 7a6.66 6.66 0 006.667 6.667A6.66 6.66 0 0013.667 7 6.66 6.66 0 007.001.333zm3.334 9.06l-.94.94L7.001 7.94l-2.394 2.394-.94-.94L6.061 7 3.667 4.607l.94-.94L7.001 6.06l2.393-2.393.94.94L7.941 7l2.393 2.393z"
            ></path>
        </svg>
    )
}

export const InfoIcon = ({
    fill,
    width = '14px',
    height = '14px',
    ...props
}) => {
    const theme = useTheme()
    fill = fill ?? theme.palette.warning.base.active

    return (
        <svg {...props} viewBox="0 0 14 14" height={height} width={width}>
            <path
                fill={fill}
                d="M7 .333A6.67 6.67 0 00.335 7a6.669 6.669 0 006.667 6.667A6.669 6.669 0 0013.667 7 6.67 6.67 0 007.001.333zm.667 10H6.334V9h1.333v1.334zm0-2.666H6.334v-4h1.333v4z"
            ></path>
        </svg>
    )
}

export const AlertIconBanner = (props = {}) => (
    <svg {...props} viewBox="0 0 24 24" height={'24px'}>
        <circle cx="12" cy="12" r="12" fill="#fff" />
        <path
            fill="#ED746F"
            d="M12.606 4.618c-.237-.443-.975-.443-1.212 0l-6.171 11.53a.672.672 0 00.268.907c.103.058.22.088.338.088h12.342a.69.69 0 00.588-.328.671.671 0 00.018-.667l-6.17-11.53zm.08 10.49h-1.371v-1.356h1.371v1.356zm-1.371-2.712V9.005h1.371v3.39h-1.371z"
        />
    </svg>
)

export const DoneIcon = (props = {}) => (
    <svg
        viewBox="0 0 50 50"
        height="24px"
        width="24px"
        {...props}
        fill="#18A957"
    >
        <path d="M18.9 35.7 7.7 24.5 9.85 22.35 18.9 31.4 38.1 12.2 40.25 14.35Z" />
    </svg>
)

export const ArrowDownIcon = ({ wrapperProps = {}, fill, ...rest }) => {
    const theme = useTheme()
    fill = fill ?? theme.palette.neutral.base[0]

    return (
        <div {...wrapperProps}>
            <svg viewBox="0 0 8 4" fill="none" {...rest}>
                <path
                    d="M3.99373 3.99882C3.86044 3.99905 3.73128 3.95838 3.62865 3.88388L0.206069 1.38517C0.0895779 1.30034 0.0163207 1.17845 0.00241378 1.04631C-0.0114932 0.914161 0.0350893 0.782588 0.131913 0.680533C0.228737 0.578477 0.367872 0.514298 0.518708 0.502115C0.669545 0.489931 0.819728 0.530741 0.93622 0.615566L3.99373 2.85441L7.05123 0.695525C7.10958 0.654014 7.17672 0.623014 7.24879 0.604308C7.32085 0.585601 7.39643 0.579558 7.47117 0.586524C7.54591 0.59349 7.61835 0.613328 7.68431 0.644898C7.75027 0.676469 7.80847 0.719149 7.85554 0.770486C7.90778 0.82187 7.94734 0.882152 7.97175 0.947555C7.99616 1.01296 8.00489 1.08207 7.9974 1.15057C7.9899 1.21907 7.96634 1.28547 7.92818 1.34561C7.89003 1.40576 7.83811 1.45836 7.77568 1.50011L4.3531 3.91386C4.24752 3.97659 4.12099 4.0065 3.99373 3.99882Z"
                    fill={fill}
                />
            </svg>
        </div>
    )
}

export const TwitchIcon = ({ ...props }) => (
    <svg
        {...props}
        width="27"
        height="27"
        viewBox="0 0 27 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M6.50869 0L1.6875 4.82119V22.1788H7.47394V27L12.2951 22.1788H16.1494L24.8299 13.5V0H6.50869ZM22.9011 12.5364L19.0451 16.3924H15.1875L11.8125 19.7674V16.3924H7.47394V1.92881H22.9011V12.5364Z"
            fill="black"
        />
        <path
            d="M20.0087 5.30322H18.0799V11.0863H20.0087V5.30322ZM14.7049 5.30322H12.7761V11.0863H14.7049V5.30322Z"
            fill="black"
        />
    </svg>
)

export const ChatIcon = (props = {}) => (
    <svg {...props} viewBox="0 0 35 32">
        <path
            fill="#fff"
            d="M11.258 14.563a2.08 2.08 0 11-4.16 0 2.08 2.08 0 014.16 0zm8.322 0a2.08 2.08 0 11-4.161 0 2.08 2.08 0 014.161 0zm6.241 2.08a2.08 2.08 0 100-4.161 2.08 2.08 0 000 4.161z"
        />
        <path
            fill="#fff"
            d="M5.36 30.796l.042-.008c3.807-.755 6.133-1.752 7.215-2.3a18.85 18.85 0 004.883.637c9.19 0 16.643-6.52 16.643-14.562C34.143 6.52 26.69 0 17.5 0 8.308 0 .856 6.52.856 14.563c0 3.661 1.546 7.01 4.099 9.57a21.713 21.713 0 01-1.09 4.822l-.007.023a22.29 22.29 0 01-.507 1.325c-.165.387.154.82.568.753.482-.079.962-.165 1.442-.26zm1.665-6.466a2.08 2.08 0 00-.597-1.666c-2.205-2.214-3.491-5.047-3.491-8.101 0-6.64 6.25-12.483 14.563-12.483s14.562 5.842 14.562 12.483c0 6.643-6.25 12.482-14.562 12.482a16.768 16.768 0 01-4.344-.566 2.08 2.08 0 00-1.48.154c-.805.408-2.58 1.186-5.48 1.858.405-1.358.683-2.751.829-4.16z"
        />
    </svg>
)

export const CalendarIcon = ({
    wrapperProps = {},
    fill = '#171428',
    width = 12,
    height = 14,
    ...rest
}) => {
    return (
        <div {...wrapperProps}>
            <svg viewBox="0 0 12 14" width={width} height={height} {...rest}>
                <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
                    <g fill={fill} fillRule="nonzero">
                        <path d="M10.666 1.75h-.583V.583H8.916V1.75H3.083V.583H1.916V1.75h-.583A1.17 1.17 0 00.166 2.917v9.333a1.17 1.17 0 001.167 1.167h9.333a1.17 1.17 0 001.167-1.167V2.917a1.17 1.17 0 00-1.167-1.167zm0 10.5H1.333V4.667h9.333v7.583z"></path>
                    </g>
                </g>
            </svg>
        </div>
    )
}

// ERP ICONS
//TODO THEME PALETTE COLORS
export const SearchIcon = ({
    fill = '#3E3B4C',
    width = 11,
    height = 11,
    ...props
}) => (
    <svg
        {...props}
        width={width}
        height={height}
        fill={fill}
        viewBox="0 0 11 11"
    >
        <path
            fill={fill}
            d="M8.042 7.167H7.58l-.163-.158a3.792 3.792 0 10-.408.408l.157.164v.46l2.916 2.912.87-.87-2.911-2.916zm-3.5 0a2.621 2.621 0 01-2.625-2.625 2.621 2.621 0 012.625-2.625 2.621 2.621 0 012.625 2.625 2.621 2.621 0 01-2.625 2.625z"
        ></path>
    </svg>
)

export const LogoIcon = (props = {}) => {
    return (
        <svg {...props} width="56" height="23" fill="none" viewBox="0 0 56 23">
            <path
                fill="#464A53"
                d="M.896.008H3.92v14.256h7.224V17H.896V.008zM12.621 11.24c0-.912.16-1.736.48-2.472a5.926 5.926 0 011.344-1.92 5.872 5.872 0 011.992-1.224 6.914 6.914 0 012.448-.432c.864 0 1.68.144 2.448.432a5.872 5.872 0 011.992 1.224c.56.528 1 1.168 1.32 1.92.336.736.504 1.56.504 2.472 0 .912-.168 1.744-.504 2.496a5.692 5.692 0 01-1.32 1.896 5.872 5.872 0 01-1.992 1.224 6.914 6.914 0 01-2.448.432c-.864 0-1.68-.144-2.448-.432a5.872 5.872 0 01-1.992-1.224 5.997 5.997 0 01-1.344-1.896c-.32-.752-.48-1.584-.48-2.496zm2.88 0c0 .448.072.88.216 1.296.16.416.384.784.672 1.104.304.32.664.576 1.08.768.416.192.888.288 1.416.288.528 0 1-.096 1.416-.288a3.211 3.211 0 001.056-.768 3.02 3.02 0 00.672-1.104c.16-.416.24-.848.24-1.296 0-.448-.08-.88-.24-1.296a3.02 3.02 0 00-.672-1.104 3.211 3.211 0 00-1.056-.768 3.342 3.342 0 00-1.416-.288c-.528 0-1 .096-1.416.288a3.49 3.49 0 00-1.08.768c-.288.32-.512.688-.672 1.104a3.934 3.934 0 00-.216 1.296zm24.32-5.76v10.488c0 1.04-.127 1.976-.383 2.808-.256.848-.656 1.56-1.2 2.136-.528.592-1.2 1.048-2.016 1.368-.816.32-1.784.48-2.904.48-1.072 0-2.088-.136-3.048-.408-.96-.272-1.848-.768-2.664-1.488l1.728-2.352a7.042 7.042 0 001.8 1.224c.624.288 1.344.432 2.16.432.688 0 1.264-.096 1.728-.288.48-.192.856-.456 1.128-.792.288-.336.488-.744.6-1.224.128-.464.192-.984.192-1.56v-.84h-.048c-.416.56-.968.984-1.656 1.272a5.698 5.698 0 01-2.112.408c-.864 0-1.648-.152-2.352-.456a5.93 5.93 0 01-1.824-1.272 5.58 5.58 0 01-1.152-1.872 6.465 6.465 0 01-.408-2.304c0-.848.128-1.64.384-2.376a5.49 5.49 0 011.128-1.92 5.242 5.242 0 011.776-1.272c.704-.32 1.504-.48 2.4-.48.816 0 1.576.16 2.28.48.704.32 1.264.832 1.68 1.536h.048V5.48h2.736zm-6.143 2.304c-.512 0-.976.088-1.392.264-.416.16-.776.392-1.08.696-.288.288-.52.648-.696 1.08-.16.416-.24.88-.24 1.392 0 .464.08.896.24 1.296a3.36 3.36 0 001.8 1.776c.416.176.864.264 1.344.264.528 0 1-.088 1.416-.264a3.223 3.223 0 001.08-.696 3.06 3.06 0 00.696-1.08c.16-.416.24-.864.24-1.344 0-1.008-.304-1.824-.912-2.448-.608-.624-1.44-.936-2.496-.936zm8.949 3.456c0-.912.16-1.736.48-2.472a5.926 5.926 0 011.344-1.92 5.872 5.872 0 011.992-1.224 6.914 6.914 0 012.448-.432c.864 0 1.68.144 2.448.432a5.872 5.872 0 011.992 1.224c.56.528 1 1.168 1.32 1.92.336.736.504 1.56.504 2.472 0 .912-.168 1.744-.504 2.496a5.692 5.692 0 01-1.32 1.896 5.872 5.872 0 01-1.992 1.224 6.914 6.914 0 01-2.448.432c-.864 0-1.68-.144-2.448-.432a5.872 5.872 0 01-1.992-1.224 5.997 5.997 0 01-1.344-1.896c-.32-.752-.48-1.584-.48-2.496zm2.88 0c0 .448.072.88.216 1.296.16.416.384.784.672 1.104.304.32.664.576 1.08.768.416.192.888.288 1.416.288.528 0 1-.096 1.416-.288a3.211 3.211 0 001.056-.768 3.02 3.02 0 00.672-1.104c.16-.416.24-.848.24-1.296 0-.448-.08-.88-.24-1.296a3.02 3.02 0 00-.672-1.104 3.211 3.211 0 00-1.056-.768 3.342 3.342 0 00-1.416-.288c-.528 0-1 .096-1.416.288a3.49 3.49 0 00-1.08.768c-.288.32-.512.688-.672 1.104a3.934 3.934 0 00-.216 1.296z"
            ></path>
        </svg>
    )
}

export const AlertIconGoogle = (props = {}) => {
    return (
        <svg {...props} width="20" height="20" fill="none" viewBox="0 0 20 20">
            <path
                fill="#F23157"
                d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm1 15H9v-2h2v2zm0-4H9V5h2v6z"
            ></path>
        </svg>
    )
}

export const GoogleIcon = (props = {}) => {
    return (
        <svg {...props} width="33" height="32" fill="none" viewBox="0 0 33 32">
            <path
                fill="#4285F4"
                fillRule="evenodd"
                d="M32.5 16.364c0-1.135-.104-2.226-.297-3.273H16.826v6.19h8.787c-.378 2-1.529 3.694-3.258 4.828v4.015h5.277c3.087-2.786 4.868-6.888 4.868-11.76z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#34A853"
                fillRule="evenodd"
                d="M16.826 32c4.409 0 8.104-1.433 10.806-3.876l-5.277-4.015c-1.462.96-3.332 1.527-5.529 1.527-4.252 0-7.851-2.814-9.135-6.596H2.237v4.145C4.923 28.415 10.444 32 16.827 32z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#FBBC05"
                fillRule="evenodd"
                d="M7.691 19.04A9.443 9.443 0 017.18 16c0-1.055.186-2.08.512-3.04V8.815H2.237a15.733 15.733 0 000 14.37L7.69 19.04z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#EA4335"
                fillRule="evenodd"
                d="M16.826 6.364c2.398 0 4.55.807 6.242 2.392l4.682-4.589C24.923 1.585 21.227 0 16.826 0 10.444 0 4.923 3.586 2.236 8.815l5.455 4.145c1.284-3.782 4.883-6.596 9.136-6.596z"
                clipRule="evenodd"
            ></path>
        </svg>
    )
}

export const ExitIcon = ({
    fill = '#3E3B4C',
    width = 20,
    height = 18,
    ...props
}) => (
    <svg
        {...props}
        width={width}
        height={height}
        fill={fill}
        viewBox="0 0 20 18"
    >
        <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
            <g fill={fill} fillRule="nonzero">
                <path d="M15 4l-1.41 1.41L16.17 8H6v2h10.17l-2.58 2.58L15 14l5-5-5-5zM2 2h8V0H2C.9 0 0 .9 0 2v14c0 1.1.9 2 2 2h8v-2H2V2z"></path>
            </g>
        </g>
    </svg>
)

export const Logo = ({
    fill = '#3E3B4C',
    width = 43,
    height = 17,
    ...props
}) => (
    <svg
        {...props}
        width={width}
        height={height}
        fill={fill}
        viewBox="0 0 43 17"
    >
        <path
            fill={fill}
            d="M.896.008h11.256v2.736H3.92V6.92h7.8v2.736h-7.8v4.608h8.664V17H.896V.008zm14.792 0h5.904c.816 0 1.6.08 2.352.24.768.144 1.448.4 2.04.768A4.08 4.08 0 0127.4 2.504c.352.624.528 1.416.528 2.376 0 1.232-.344 2.264-1.032 3.096-.672.832-1.64 1.336-2.904 1.512L28.504 17h-3.648L20.92 9.8h-2.208V17h-3.024V.008zm5.376 7.2c.432 0 .864-.016 1.296-.048a4.368 4.368 0 001.176-.288c.368-.16.664-.392.888-.696.224-.32.336-.76.336-1.32 0-.496-.104-.896-.312-1.2a1.856 1.856 0 00-.816-.672 3.553 3.553 0 00-1.128-.312 9.867 9.867 0 00-1.176-.072h-2.616v4.608h2.352zm9.861-7.2h5.712c.816 0 1.6.08 2.352.24.768.16 1.44.432 2.016.816a3.911 3.911 0 011.368 1.512c.352.624.528 1.408.528 2.352 0 1.072-.184 1.936-.552 2.592a4.039 4.039 0 01-1.488 1.536c-.624.352-1.352.592-2.184.72-.816.128-1.672.192-2.568.192h-2.16V17h-3.024V.008zm4.848 7.368c.432 0 .88-.016 1.344-.048a4.002 4.002 0 001.272-.288c.4-.16.72-.4.96-.72.256-.32.384-.768.384-1.344 0-.528-.112-.944-.336-1.248a2.097 2.097 0 00-.864-.72 3.463 3.463 0 00-1.176-.336A11.309 11.309 0 0036.11 2.6h-2.16v4.776h1.824z"
        ></path>
    </svg>
)

export const OpenIcon = ({
    fill = '#3E3B4C',
    width = 6,
    height = 10,
    ...props
}) => {
    return (
        <svg {...props} width={width} height={height} viewBox="0 0 6 10">
            <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
                <g fill={fill} fillRule="nonzero">
                    <path d="M.6 8.682c0 .91 1.117 1.348 1.735.679l3.399-3.683a1 1 0 000-1.356L2.334.639C1.718-.03.6.407.6 1.318v7.364z"></path>
                </g>
            </g>
        </svg>
    )
}

export const CloseIcon = ({
    fill = '#3E3B4C',
    width = 14,
    height = 14,
    ...props
}) => {
    return (
        <svg {...props} width={width} height={height} viewBox="0 0 14 14">
            <g fill={fill} fillRule="evenodd" stroke="none" strokeWidth="1">
                <g fill={fill} fillRule="nonzero">
                    <path d="M7 .333A6.66 6.66 0 00.333 7 6.66 6.66 0 007 13.667 6.66 6.66 0 0013.667 7 6.66 6.66 0 007 .333zm3.333 9.06l-.94.94L7 7.94l-2.393 2.393-.94-.94L6.06 7 3.667 4.607l.94-.94L7 6.06l2.393-2.393.94.94L7.94 7l2.393 2.393z"></path>
                </g>
            </g>
        </svg>
    )
}

export const SortIcon = ({ width = 10, height = 12, ...props }) => {
    return (
        <svg
            {...props}
            width={width}
            height={height}
            fill="none"
            viewBox="0 0 10 12"
        >
            <path
                fill="#171428"
                d="M.5 12h3v-2h-3v2zm0-12v2h9V0h-9zm0 7h6V5h-6v2z"
            ></path>
        </svg>
    )
}

export const ActionsIcon = ({
    width = 12,
    height = 16,
    fill = '#171428',
    ...props
}) => (
    <svg {...props} viewBox="0 0 4 16" width={width} height={height}>
        <path
            fill={fill}
            d="M2 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2C.9 6 0 6.9 0 8s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
        ></path>
    </svg>
)

export const MemberIcon = ({
    fill = '#B2B1B7',
    width = 24,
    height = 24,
    ...props
}) => {
    return (
        <svg {...props} width={width} height={height} viewBox="0 0 32 32">
            <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
                <g fill={fill} fillRule="nonzero" transform="translate(5 5)">
                    <path d="M11 11a5.332 5.332 0 005.334-5.333A5.332 5.332 0 0011.001.334a5.332 5.332 0 00-5.334 5.333A5.332 5.332 0 0011.001 11zm0 2.667C7.44 13.667.335 15.454.335 19v2.667h21.333V19c0-3.546-7.106-5.333-10.666-5.333z"></path>
                </g>
            </g>
        </svg>
    )
}

export const ContractIcon = ({
    fill = '#B2B1B7',
    width = 24,
    height = 24,
    ...props
}) => {
    return (
        <svg {...props} width={width} height={height} viewBox="0 0 32 32">
            <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
                <g fill={fill} fillRule="nonzero" transform="translate(3 3)">
                    <path d="M24.166 6h-5.333V3.333A2.657 2.657 0 0016.166.667h-5.333a2.657 2.657 0 00-2.667 2.666V6H2.833A2.646 2.646 0 00.179 8.667L.166 23.333A2.657 2.657 0 002.833 26h21.333a2.657 2.657 0 002.667-2.667V8.667A2.657 2.657 0 0024.166 6zm-8 0h-5.333V3.333h5.333V6z"></path>
                </g>
            </g>
        </svg>
    )
}

export const HistoryIcon = ({
    fill = '#B2B1B7',
    width = 24,
    height = 24,
    ...props
}) => {
    return (
        <svg {...props} width={width} height={height} viewBox="0 0 32 32">
            <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
                <g fill={fill} fillRule="nonzero" transform="translate(2 4)">
                    <path d="M16.334 0c-6.627 0-12 5.373-12 12h-4l5.187 5.187.093.186L11.001 12H7a9.327 9.327 0 019.333-9.333A9.326 9.326 0 0125.667 12a9.326 9.326 0 01-9.333 9.333 9.258 9.258 0 01-6.587-2.746L7.854 20.48a11.94 11.94 0 008.48 3.52c6.627 0 12-5.373 12-12s-5.373-12-12-12zm-1.333 6.667v6.666l5.706 3.387.96-1.613-4.666-2.774V6.667h-2z"></path>
                </g>
            </g>
        </svg>
    )
}

export const AddIcon = ({
    fill = '#fff',
    width = 10,
    height = 10,
    ...props
}) => {
    return (
        <svg {...props} width={width} height={height} viewBox="0 0 10 10">
            <path
                fill={fill}
                d="M9.083 5.587h-3.5v3.5H4.416v-3.5h-3.5V4.42h3.5V.92h1.167v3.5h3.5v1.167z"
            ></path>
        </svg>
    )
}

export const ArrowAccordionIcon = ({
    fill = '#171428',
    width = 6,
    height = 4,
    ...props
}) => {
    return (
        <svg {...props} width={width} height={height} viewBox="0 0 6 4">
            <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
                <g fill={fill} fillRule="nonzero">
                    <path d="M0.0839844 0.833496L3.00065 3.75016 5.91732 0.833496z"></path>
                </g>
            </g>
        </svg>
    )
}

export const TrashIcon = ({
    width = 10,
    height = 10,
    fill = '#F23157',
    ...props
}) => (
    <svg {...props} viewBox="0 0 7 10" height={height} width={width}>
        <path
            fill={fill}
            d="M.75 8.208a.92.92 0 00.917.917h3.666a.92.92 0 00.917-.917v-5.5H.75v5.5zm5.958-6.875H5.104L4.646.875H2.354l-.458.458H.292v.917h6.416v-.917z"
        ></path>
    </svg>
)

export const TeamIcon = ({
    width = 24,
    height = 24,
    fill = '#B2B1B7',
    ...props
}) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        {...props}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_1205_48838)">
            <path
                d="M12 12.75C13.63 12.75 15.07 13.14 16.24 13.65C17.32 14.13 18 15.21 18 16.38V18H6V16.39C6 15.21 6.68 14.13 7.76 13.66C8.93 13.14 10.37 12.75 12 12.75ZM4 13C5.1 13 6 12.1 6 11C6 9.9 5.1 9 4 9C2.9 9 2 9.9 2 11C2 12.1 2.9 13 4 13ZM5.13 14.1C4.76 14.04 4.39 14 4 14C3.01 14 2.07 14.21 1.22 14.58C0.48 14.9 0 15.62 0 16.43V18H4.5V16.39C4.5 15.56 4.73 14.78 5.13 14.1ZM20 13C21.1 13 22 12.1 22 11C22 9.9 21.1 9 20 9C18.9 9 18 9.9 18 11C18 12.1 18.9 13 20 13ZM24 16.43C24 15.62 23.52 14.9 22.78 14.58C21.93 14.21 20.99 14 20 14C19.61 14 19.24 14.04 18.87 14.1C19.27 14.78 19.5 15.56 19.5 16.39V18H24V16.43ZM12 6C13.66 6 15 7.34 15 9C15 10.66 13.66 12 12 12C10.34 12 9 10.66 9 9C9 7.34 10.34 6 12 6Z"
                fill={fill}
            />
        </g>
        <defs>
            <clipPath id="clip0_1205_48838">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
)

export const EditIcon = ({
    width = 10,
    height = 10,
    fill = '#171428',
    ...props
}) => (
    <svg {...props} viewBox="0 0 9 10" height={height} width={width}>
        <path
            fill={fill}
            d="M.375 7.405v1.72h1.719l5.069-5.07-1.719-1.719-5.069 5.07zm8.117-4.68a.456.456 0 000-.645L7.42 1.007a.456.456 0 00-.647 0l-.838.839 1.718 1.719.84-.84z"
        ></path>
    </svg>
)

export const CloseSelectIcon = ({
    width = 14,
    height = 14,
    fill = '#171428',
    ...props
}) => (
    <svg {...props} height={height} width={width} viewBox="0 0 14 14">
        <path
            fill={fill}
            d="M7.002.878a6.125 6.125 0 100 12.25 6.125 6.125 0 000-12.25zM9.263 9.33l-.902-.004L7 7.706 5.645 9.324l-.903.005a.109.109 0 01-.11-.11c0-.026.01-.05.026-.07l1.779-2.12L4.657 4.91a.11.11 0 01.083-.18l.904.004 1.358 1.62L8.36 4.736l.902-.004c.06 0 .11.048.11.11 0 .025-.01.05-.027.07L7.57 7.03l1.778 2.12c.016.02.026.045.026.07 0 .06-.05.11-.11.11z"
        ></path>
    </svg>
)

export const ArrowSelectIcon = ({
    width = 8,
    height = 5,
    fill = '#171428',
    ...props
}) => (
    <svg {...props} height={height} width={width} viewBox="0 0 8 5">
        <path
            fill={fill}
            d="M1.323.01L4 2.683 6.678.011 7.5.833 4 4.333.5.833l.823-.822z"
        ></path>
    </svg>
)

export const CloseIconToast = ({
    fill,
    width = '10px',
    height = '10px',
    ...props
}) => {
    return (
        <svg {...props} viewBox="0 0 10 10" height={height} width={width}>
            <path
                fill={fill}
                d="M9.667 1.274l-.94-.94L5.001 4.06 1.274.333l-.94.94L4.061 5 .334 8.727l.94.94L5.001 5.94l3.726 3.727.94-.94L5.941 5l3.726-3.726z"
            ></path>
        </svg>
    )
}

export const ProjectIcon = ({
    width = 24,
    height = 24,
    fill = '#B2B1B7',
    ...props
}) => (
    <svg {...props} viewBox="0 0 24 24" height={height} width={width}>
        <g clipPath="url(#clip0_3418_25695)">
            <path
                fill={fill}
                d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"
            ></path>
        </g>
        <defs>
            <clipPath id="clip0_3418_25695">
                <path fill="#fff" d="M0 0H24V24H0z"></path>
            </clipPath>
        </defs>
    </svg>
)

export const CustomerIcon = ({
    width = 24,
    height = 24,
    fill = '#B2B1B7',
    ...props
}) => (
    <svg {...props} viewBox="0 0 24 24" height={height} width={width}>
        <g clipPath="url(#clip0_3418_25700)">
            <path
                fill={fill}
                d="M19.5 3h-4.18c-.42-1.16-1.52-2-2.82-2-1.3 0-2.4.84-2.82 2H5.5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12h-12v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1V19z"
            ></path>
        </g>
        <defs>
            <clipPath id="clip0_3418_25700">
                <path
                    fill="#fff"
                    d="M0 0H24V24H0z"
                    transform="translate(.5)"
                ></path>
            </clipPath>
        </defs>
    </svg>
)

export const LinkIcon = ({
    width = 14,
    height = 14,
    fill = '#FFF',
    ...props
}) => (
    <svg {...props} width={width} height={height} viewBox="0 0 14 14">
        <g clipPath="url(#clip0_1311_40029)">
            <path
                d="M2.27508 6.99998C2.27508 6.00248 3.08591 5.19165 4.08341 5.19165H6.41675V4.08331H4.08341C2.47341 4.08331 1.16675 5.38998 1.16675 6.99998C1.16675 8.60998 2.47341 9.91665 4.08341 9.91665H6.41675V8.80831H4.08341C3.08591 8.80831 2.27508 7.99748 2.27508 6.99998ZM4.66675 7.58331H9.33341V6.41665H4.66675V7.58331ZM9.91675 4.08331H7.58341V5.19165H9.91675C10.9142 5.19165 11.7251 6.00248 11.7251 6.99998C11.7251 7.99748 10.9142 8.80831 9.91675 8.80831H7.58341V9.91665H9.91675C11.5267 9.91665 12.8334 8.60998 12.8334 6.99998C12.8334 5.38998 11.5267 4.08331 9.91675 4.08331Z"
                fill="#171428"
            />
        </g>
        <defs>
            <clipPath id="clip0_1311_40029">
                <rect width="14" height="14" fill={fill} />
            </clipPath>
        </defs>
    </svg>
)

export const PlusIcon = ({
    width = 10,
    height = 10,
    fill = '#FFFFFF',
    ...props
}) => (
    <svg {...props} width={width} height={height} viewBox="0 0 10 10">
        <path
            fill={fill}
            d="M9.083 5.583h-3.5v3.5H4.417v-3.5h-3.5V4.416h3.5v-3.5h1.166v3.5h3.5v1.167z"
        ></path>
    </svg>
)

export const CloseSideBarRightIcon = ({
    width = 20,
    height = 20,
    fill = '#171428',
    ...props
}) => (
    <svg {...props} width={width} height={height} viewBox="0 0 20 20">
        <path
            fill={fill}
            d="M12.59 6L10 8.59 7.41 6 6 7.41 8.59 10 6 12.59 7.41 14 10 11.41 12.59 14 14 12.59 11.41 10 14 7.41 12.59 6zM10 0C4.47 0 0 4.47 0 10s4.47 10 10 10 10-4.47 10-10S15.53 0 10 0zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
        ></path>
    </svg>
)

export const FinalBalanceIcon = ({
    width = 24,
    height = 24,
    fill = '#3E3B4C',
    ...props
}) => (
    <svg
        {...props}
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 24 24"
    >
        <g clipPath="url(#clip0_1504_35482)">
            <path
                fill={fill}
                d="M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6z"
            ></path>
        </g>
        <defs>
            <clipPath id="clip0_1504_35482">
                <path fill="#fff" d="M0 0H24V24H0z"></path>
            </clipPath>
        </defs>
    </svg>
)

export const ServiceIcon = ({
    width = 24,
    height = 24,
    fill = '#3E3B4C',
    ...props
}) => (
    <svg
        {...props}
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 24 24"
    >
        <g fill={fill} clipPath="url(#clip0_1311_18222)">
            <path d="M16.24 11.51l1.57-1.57-3.75-3.75-1.57 1.57-4.14-4.13c-.78-.78-2.05-.78-2.83 0l-1.9 1.9c-.78.78-.78 2.05 0 2.83l4.13 4.13L3 17.25V21h3.75l4.76-4.76 4.13 4.13c.95.95 2.23.6 2.83 0l1.9-1.9c.78-.78.78-2.05 0-2.83l-4.13-4.13zm-7.06-.44L5.04 6.94l1.89-1.9L8.2 6.31 7.02 7.5l1.41 1.41 1.19-1.19 1.45 1.45-1.89 1.9zm7.88 7.89l-4.13-4.13 1.9-1.9 1.45 1.45-1.19 1.19 1.41 1.41 1.19-1.19 1.27 1.27-1.9 1.9zM20.71 7.04a.996.996 0 000-1.41l-2.34-2.34c-.47-.47-1.12-.29-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"></path>
        </g>
        <defs>
            <clipPath id="clip0_1311_18222">
                <path fill="#fff" d="M0 0H24V24H0z"></path>
            </clipPath>
        </defs>
    </svg>
)

export const StatusIconSuccess = ({
    width = 24,
    height = 24,
    fill = '#D2F3D9',
    fillPath = '#6FD285',
    ...props
}) => (
    <svg
        {...props}
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 24 24"
    >
        <g clipPath="url(#clip0_1504_35523)">
            <rect width={width} height={height} fill={fill} rx="12" />
            <path
                fill={fillPath}
                d="M16.59 7.58L10 14.17l-3.59-3.58L5 12l5 5 8-8-1.41-1.42zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
            />
        </g>
        <defs>
            <clipPath id="clip0_1504_35523">
                <rect width={width} height={height} fill="#fff" rx="12"></rect>
            </clipPath>
        </defs>
    </svg>
)

export const StatusIconWarning = ({
    width = 24,
    height = 24,
    fill = '#FFEFC0',
    pathFill = '#FFC107',
    ...props
}) => (
    <svg
        {...props}
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 24 24"
    >
        <rect width={width} height={height} fill={fill} rx="12" />
        <path
            fill={pathFill}
            d="M11 15h2v2h-2v-2zm0-8h2v6h-2V7zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        />
    </svg>
)

export const StatusIconError = ({
    width = 24,
    height = 24,
    fill = '#FFD8DF',
    pathFill = '#F23157',
    ...props
}) => (
    <svg
        {...props}
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 24 24"
    >
        <rect width={width} height={height} fill={fill} rx="12" />
        <path
            fill={pathFill}
            d="M11 15h2v2h-2v-2zm0-8h2v6h-2V7zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        />
    </svg>
)

export const CostsProjectIcon = ({
    width = 24,
    height = 24,
    fill = '#3E3B4C',
    ...props
}) => (
    <svg
        {...props}
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 24 24"
    >
        <g clipPath="url(#clip0_1504_35841)">
            <path
                fill={fill}
                d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"
            ></path>
        </g>
        <defs>
            <clipPath id="clip0_1504_35841">
                <path fill="#fff" d="M0 0H24V24H0z"></path>
            </clipPath>
        </defs>
    </svg>
)

export const CurrencyIcon = ({
    width = 14,
    height = 14,
    fill = '#171428',
    pathFill = '#fff',
    ...props
}) => (
    <svg
        {...props}
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 14 14"
    >
        <g clipPath="url(#clip0_1581_40437)">
            <path
                fill={fill}
                d="M8.75 10.792A3.78 3.78 0 015.39 8.75h3.36V7.583H5.005A3.87 3.87 0 014.958 7c0-.198.018-.39.047-.583H8.75V5.25H5.39a3.787 3.787 0 015.827-1.126l1.033-1.032a5.224 5.224 0 00-3.5-1.342 5.252 5.252 0 00-4.947 3.5H1.75v1.167h1.785a4.82 4.82 0 000 1.166H1.75V8.75h2.053a5.252 5.252 0 004.947 3.5 5.212 5.212 0 003.5-1.342l-1.038-1.032a3.737 3.737 0 01-2.462.916z"
            ></path>
        </g>
        <defs>
            <clipPath id="clip0_1581_40437">
                <path fill={pathFill} d="M0 0H14V14H0z"></path>
            </clipPath>
        </defs>
    </svg>
)

export const PercentageIcon = ({
    width = 14,
    height = 14,
    fill = '#171428',
    ...props
}) => (
    <svg
        {...props}
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 14 14"
    >
        <path
            fill={fill}
            d="M10.793 2.042l-8.75 8.75 1.164 1.165 8.75-8.75-1.165-1.165zm-6.708.875a1.166 1.166 0 10-.003 2.333 1.166 1.166 0 00.003-2.333zM9.918 8.75a1.167 1.167 0 10-.002 2.333 1.167 1.167 0 00.002-2.333z"
        ></path>
    </svg>
)

export const ClockIcon = ({
    width = 14,
    height = 14,
    fill = '#171428',
    pathFill = '#fff',
    ...props
}) => (
    <svg
        {...props}
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 14 14"
    >
        <g clipPath="url(#clip0_1581_40399)">
            <path
                fill={fill}
                d="M7 1.167C3.792 1.167 1.167 3.792 1.167 7S3.792 12.833 7 12.833 12.833 10.208 12.833 7 10.208 1.167 7 1.167zM9.45 9.45L6.417 7.583v-3.5h.875v3.034l2.624 1.575-.466.758z"
            ></path>
        </g>
        <defs>
            <clipPath id="clip0_1581_40399">
                <path fill={pathFill} d="M0 0H14V14H0z"></path>
            </clipPath>
        </defs>
    </svg>
)

export const RemoveIconMulti = ({
    width = 8,
    height = 8,
    fill = '#646270',
    pathFill = '#fff',
    ...props
}) => (
    <svg {...props} width={width} height={height} fill="none" viewBox="0 0 8 8">
        <g clipPath="url(#clip0_1788_39917)">
            <path
                fill={fill}
                d="M6.333 2.136l-.47-.47L4 3.529 2.136 1.666l-.47.47L3.53 3.999 1.667 5.863l.47.47L4 4.469l1.863 1.864.47-.47L4.47 3.999l1.863-1.863z"
            ></path>
        </g>
        <defs>
            <clipPath id="clip0_1788_39917">
                <path fill={pathFill} d="M0 0H8V8H0z"></path>
            </clipPath>
        </defs>
    </svg>
)

export const ArrowIcon = ({
    width = 24,
    height = 24,
    fill = '#171428',
    pathFill = '#fff',
    ...props
}) => (
    <svg
        {...props}
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 24 24"
    >
        <g clipPath="url(#clip0_2299_31404)">
            <path fill={fill} d="M10 17l5-5-5-5v10z"></path>
        </g>
        <defs>
            <clipPath id="clip0_2299_31404">
                <path fill={pathFill} d="M0 0H24V24H0z"></path>
            </clipPath>
        </defs>
    </svg>
)

export const ExportIcon = ({
    width = 14,
    height = 14,
    fill = '#7F63F4',
    pathFill = '#fff',
    ...props
}) => (
    <svg
        {...props}
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 14 14"
    >
        <g clipPath="url(#clip0_2565_30658)">
            <path
                fill={fill}
                d="M12.25 1.756H1.75A1.17 1.17 0 00.583 2.923V5.25H1.75V2.91h10.5v8.185H1.75V8.75H.583v2.34a1.16 1.16 0 001.167 1.154h10.5a1.16 1.16 0 001.167-1.155V2.923c0-.648-.525-1.167-1.167-1.167zM6.417 9.333L8.75 7 6.417 4.667v1.75H.583v1.166h5.834v1.75z"
            ></path>
        </g>
        <defs>
            <clipPath id="clip0_2565_30658">
                <path fill={pathFill} d="M0 0H14V14H0z"></path>
            </clipPath>
        </defs>
    </svg>
)

export const CloseMemberIcon = ({
    width = 10,
    height = 10,
    fill = '#171428',
    cursor = 'pointer',
    ...props
}) => (
    <svg
        {...props}
        cursor={cursor}
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 10 10"
    >
        <path
            fill={fill}
            d="M9.083 1.739L8.261.917 5 4.177 1.739.917l-.822.822 3.26 3.26-3.26 3.262.822.822 3.26-3.26 3.262 3.26.822-.822L5.823 5l3.26-3.261z"
        ></path>
    </svg>
)
export const WorkedIcon = ({
    width = 11,
    height = 11,
    fill = '#171428',
    ...props
}) => (
    <svg {...props} width={width} height={height} viewBox="0 0 11 11">
        <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
            <g fill={fill} fillRule="nonzero" transform="translate(0 1)">
                <path d="M9.167 2.25H7.333v-.916a.913.913 0 00-.916-.917H4.583a.913.913 0 00-.916.917v.916H1.833a.91.91 0 00-.912.917L.917 8.209c0 .508.408.916.916.916h7.334a.913.913 0 00.916-.916V3.167a.913.913 0 00-.916-.917zm-2.75 0H4.583v-.916h1.834v.916z"></path>
            </g>
        </g>
    </svg>
)

export const PlusTableIcon = ({
    width = 11,
    height = 11,
    fill = '#171428',
    ...props
}) => (
    <svg {...props} width={width} height={height} viewBox="0 0 11 11">
        <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
            <g fill={fill} fillRule="nonzero" transform="translate(2 2)">
                <path d="M7 4.00000156L3.99999688 4.00000156 3.99999688 7 3.00000312 7 3.00000312 4.00000156 0 4.00000156 0 2.99999844 3.00000312 2.99999844 3.00000312 0 3.99999688 0 3.99999688 2.99999844 7 2.99999844z"></path>
            </g>
        </g>
    </svg>
)

export const SellIcon = ({
    width = 11,
    height = 11,
    fill = '#171428',
    ...props
}) => (
    <svg {...props} width={width} height={height} viewBox="0 0 11 11">
        <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
            <g fill={fill} fillRule="nonzero" transform="translate(1 1)">
                <path d="M7.708.875H1.292a.916.916 0 00-.917.917v6.416c0 .505.408.917.917.917h6.416a.92.92 0 00.917-.917V1.792a.916.916 0 00-.917-.917zm0 7.333H1.292v-5.5h6.416v5.5zm-2.52-2.75a.687.687 0 11-1.375 0 .687.687 0 111.374 0zM4.5 3.625c-1.251 0-2.32.76-2.75 1.833A2.954 2.954 0 004.5 7.292c1.251 0 2.32-.761 2.75-1.834A2.954 2.954 0 004.5 3.625zm0 2.98a1.146 1.146 0 110-2.293 1.146 1.146 0 010 2.292z"></path>
            </g>
        </g>
    </svg>
)

export const ArrowOpenedIcon = ({
    width = 24,
    height = 24,
    fill = '#171428',
    ...props
}) => (
    <svg
        {...props}
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 24 24"
    >
        <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
            <g fill={fill} fillRule="nonzero" transform="rotate(90 4 13.5)">
                <path d="M0 10L5 5 0 0z"></path>
            </g>
        </g>
    </svg>
)

export const UploadIcon = ({
    width = 24,
    height = 24,
    fill = '#171428',
    ...props
}) => (
    <svg
        {...props}
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 14 14"
    >
        <path
            fill={fill}
            d="M5.25 3.969h1.155v5.286c0 .069.056.125.125.125h.937a.125.125 0 00.125-.125V3.969H8.75c.105 0 .162-.12.098-.202l-1.75-2.215a.125.125 0 00-.197 0l-1.75 2.214a.126.126 0 00.099.203zm7.469 4.817h-.938a.125.125 0 00-.125.125v2.407H2.344V8.91a.125.125 0 00-.125-.125H1.28a.125.125 0 00-.125.125v3.094a.5.5 0 00.5.5h10.688a.5.5 0 00.5-.5V8.911a.125.125 0 00-.125-.125z"
        ></path>
    </svg>
)

export const NotFoundIcon = ({ width = 350, height = 147, ...props }) => (
    <svg
        {...props}
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 350 147"
    >
        <path
            fill="#7F63F4"
            d="M60.6 144v-25.8H.2V96.6L65.4 3h25.2v91.8h19.2v23.4H90.6V144h-30zm0-49.2v-55h5l-43 62.2v-7.2h38zm112.322 51.4c-16.933 0-30-6.333-39.2-19-9.067-12.8-13.6-30.8-13.6-54 0-23.6 4.533-41.533 13.6-53.8C142.922 7 155.989.8 172.922.8c17.067 0 30.133 6.2 39.2 18.6 9.067 12.267 13.6 30.133 13.6 53.6 0 23.333-4.533 41.4-13.6 54.2-9.067 12.667-22.133 19-39.2 19zm0-25.2c7.733 0 13.467-3.8 17.2-11.4 3.867-7.733 5.8-19.933 5.8-36.6s-1.933-28.667-5.8-36c-3.733-7.333-9.467-11-17.2-11-7.733 0-13.533 3.667-17.4 11-3.733 7.333-5.6 19.267-5.6 35.8 0 16.8 1.933 29.067 5.8 36.8 3.867 7.6 9.6 11.4 17.2 11.4zm127.522 23v-25.8h-60.4V96.6l65.2-93.6h25.2v91.8h19.2v23.4h-19.2V144h-30zm0-49.2v-55h5l-43 62.2v-7.2h38z"
        ></path>
    </svg>
)

export const ArrowForTable = ({
    width = 24,
    height = 25,
    pathFill = '#171428',
    ...props
}) => (
    <svg
        {...props}
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 24 25"
    >
        <g clipPath="url(#clip0_4216_37213)">
            <path
                fill={pathFill}
                d="M15.41 17.09l-4.58-4.59 4.58-4.59L14 6.5l-6 6 6 6 1.41-1.41z"
            ></path>
        </g>
        <defs>
            <clipPath id="clip0_4216_37213">
                <path
                    fill="#fff"
                    d="M0 0H24V24H0z"
                    transform="translate(0 .5)"
                ></path>
            </clipPath>
        </defs>
    </svg>
)

export const InfoIconOutlined = ({
    width = 16,
    height = 16,
    fill = '#6FD285',
    ...props
}) => (
    <svg
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 17 16"
        {...props}
    >
        <g clipPath="url(#clip0_5127_34581)">
            <path
                fill={fill}
                d="M8.233 4.666h1.334V6H8.233V4.666zm0 2.667h1.334v4H8.233v-4zm.667-6A6.67 6.67 0 002.233 8 6.67 6.67 0 008.9 14.666 6.669 6.669 0 0015.567 8 6.669 6.669 0 008.9 1.333zm0 12A5.34 5.34 0 013.567 8 5.34 5.34 0 018.9 2.666 5.34 5.34 0 0114.233 8 5.34 5.34 0 018.9 13.333z"
            ></path>
        </g>
        <defs>
            <clipPath id="clip0_5127_34581">
                <path
                    fill="#fff"
                    d="M0 0H16V16H0z"
                    transform="translate(.9)"
                ></path>
            </clipPath>
        </defs>
    </svg>
)
